import React from 'react';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import Render from '../../../components/Render';

export default function StateForm(props) {

  function updateState(e) {
    props.updateStateId(e.target.value);
  }

  function searchByState(e) {
    e.preventDefault();

    props.getServicersByState();
  }

  function setStylesBasedOnScreenSize(midStyles, smallAndLargeStyles) {
    if (props.screenWidth <= 767 || props.screenWidth >= 1200) {
      return smallAndLargeStyles
    }
    else if (props.screenWidth > 767 && props.screenWidth < 1200) {
      return midStyles
    }
  }

  

  return (
    <form onSubmit={searchByState}>
      <div style={setStylesBasedOnScreenSize({marginRight: -25, marginLeft: 10}, {marginRight: -55})} className='col-sm-3'>
        <FormControl>
          <InputLabel style={{marginLeft: -12, marginTop: 12}}>Search By State</InputLabel>
          <NativeSelect
            value={props.state_id}
            onChange={updateState}
          >
            <option value="" />
            {props.states.map(item => (
              <option key={item.state_id} value={item.state_id}>{item.state_name}, {item.state_country}</option>
            ))}
          </NativeSelect>
        </FormControl>
      </div>
      <div className='col-sm-2' style={{ display: 'inline-block' }}>
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: 15, marginLeft: 15 }}
          type="submit"
          disabled={!props.state_id}
        >
          Search
        </Button>
      </div>
    </form>
  );
}